<template>
  <modal-template class="modal-height"
                  size="intermedium"
                  close-position="left"
                  @close="$root.$emit('closeBasicInfoPurchaseNoCreate')">
    <div class="posR">
      <div class="container-onboarding container-basic-info-purchase">
        <h3> {{ $t('basicInfoPurchase.rellenaEstosDatosParaContinuar') }} </h3>
        <b-row>
          <b-col cols="12">
            <validation-observer v-slot="{ invalid }">
              <b-form @submit.prevent="basicInfo">
                <validation-provider v-slot="{ errors }"
                                     rules="required">
                  <b-form-group>
                    <b-form-input v-model="model.first_name"
                                  type="text"
                                  required
                                  :placeholder="$t('basicInfoPurchase.nombre')"
                                  name="first_name"
                                  :class="{'error': errors[0]}" />
                  </b-form-group>
                </validation-provider>
                <validation-provider v-slot="{ errors }"
                                     rules="required">
                  <b-form-group>
                    <b-form-input v-model="model.last_name"
                                  type="text"
                                  required
                                  :placeholder="$t('basicInfoPurchase.apellido')"
                                  name="last_name"
                                  :class="{'error': errors[0]}" />
                  </b-form-group>
                </validation-provider>
                <b-form-row class="mB1rem">
                  <b-col cols="4"
                         class="pR10">
                    <validation-provider v-slot="{ errors }"
                                         rules="required|min:2|max:2">
                      <b-form-input v-model="day"
                                    placeholder="DD"
                                    class="tAc"
                                    :class="{'error': errors[0] || birthdayError}"
                                    type="text"
                                    name="day"
                                    @input="fillBirthday" />
                    </validation-provider>
                  </b-col>
                  <b-col cols="4"
                         class="pR10">
                    <validation-provider v-slot="{ errors }"
                                         rules="required|min:2|max:2">
                      <b-form-input v-model="month"
                                    placeholder="MM"
                                    class="tAc"
                                    :class="{'error': errors[0] || birthdayError}"
                                    type="text"
                                    name="month"
                                    @input="fillBirthday" />
                    </validation-provider>
                  </b-col>
                  <b-col cols="4">
                    <validation-provider v-slot="{ errors }"
                                         rules="required|min:4|max:4">
                      <b-form-input v-model="year"
                                    placeholder="YYYY"
                                    class="tAc"
                                    :class="{'error': errors[0] || birthdayError}"
                                    type="text"
                                    name="year"
                                    @input="fillBirthday" />
                    </validation-provider>
                  </b-col>
                </b-form-row>
                <validation-provider v-slot="{ errors }"
                                     rules="required">
                  <b-form-group>
                    <input ref="autocomplete"
                           :placeholder="$t('userProfileOnboarding.localizacion')"
                           :class="{'error': errors[0]}"
                           class="search-location form-control"
                           name="location"
                           type="text">
                  </b-form-group>
                </validation-provider>
                <b-form-group>
                  <w-switch v-model="model.gender"
                            :value-left="$t('genre.hombre')"
                            :value-right="$t('genre.mujer')" />
                </b-form-group>
                <div class="tAc">
                  <button :disabled="invalid || isDisabled"
                          :class="{'topaz': !invalid && !isDisabled, 'transparent': invalid || isDisabled}"
                          type="submit"
                          class="btn topaz">{{ $t('basicInfoPurchase.continua') }}</button>
                </div>
              </b-form>
            </validation-observer>
          </b-col>
        </b-row>
      </div>
    </div>
    <loader v-show="loading"
            class="load-more-loader"
            :middle="true" />
  </modal-template>
</template>

<script>
import ModalTemplate from '@/components/modal-template/ModalTemplate.vue'
import WSwitch from '@/components/wswitch/WSwitch.vue'
import Loader from '@/components/loader/Loader.vue'

export default {
  components: {
    ModalTemplate,
    WSwitch,
    Loader
  },
  props: {
    eventToEmitBasic: {
      type: String,
      default: 'closeBasicInfoPurchase'
    }
  },
  data: () => ({
    model: {
      first_name: '',
      last_name: '',
      birthday: '',
      location: {},
      gender: undefined
    },
    day: '',
    month: '',
    year: '',
    loading: false,
    birthdayError: false
  }),
  computed: {
    isDisabled() {
      return (
        this.model.first_name === '' ||
        this.model.last_name === '' ||
        this.birthdayError ||
        this.$moment().diff(
          this.$moment(
            this.day + '/' + this.month + '/' + this.year,
            'DD/MM/YYYY'
          ),
          'years'
        ) < 16 ||
        this.model.location.place_id === 'undefined' ||
        this.model.gender === undefined
      )
    }
  },
  mounted() {
    this.autocomplete = new window.google.maps.places.Autocomplete(
      this.$refs.autocomplete,
      { types: ['(cities)'] }
    )
    this.autocomplete.addListener('place_changed', () => {
      let place = this.autocomplete.getPlace()
      if (place && place.geometry && place.geometry.location) {
        this.model.location = {
          place_id: place.id,
          longitude: place.geometry.location.lng(),
          latitude: place.geometry.location.lat(),
          name: place.name
        }
      }
    })
  },
  methods: {
    async basicInfo() {
      this.loading = true
      var data = {
        first_name: this.model.first_name,
        last_name: this.model.last_name,
        gender: this.model.gender ? 'm' : 'f',
        birthday: this.$moment(this.model.birthday).format('YYYY-MM-DD'),
        location: this.model.location
      }
      try {
        await this.$store.dispatch('user/update', {
          user: this.$store.state.user.detail.id,
          data: data
        })
        this.$root.$emit(this.eventToEmitBasic)
        this.loading = false
      } catch {
        this.loading = false
      }
    },
    fillBirthday() {
      if (this.day && this.month && this.year.length === 4) {
        if (
          this.$moment(
            this.day + '/' + this.month + '/' + this.year,
            'DD/MM/YYYY'
          ).isValid()
        ) {
          if (
            this.$moment().diff(
              this.$moment(
                this.day + '/' + this.month + '/' + this.year,
                'DD/MM/YYYY'
              ),
              'years'
            ) < 16
          ) {
            this.birthdayError = true
          } else {
            this.model.birthday = this.$moment(
              this.day + '/' + this.month + '/' + this.year,
              'DD/MM/YYYY'
            ).toDate()
            this.birthdayError = false
          }
        } else {
          this.birthdayError = true
        }
      }
    }
  }
}
</script>

<style lang="scss">
#wegow-default-styles {
  .container-basic-info-purchase {
    input {
      min-width: auto;
    }
    .switch-content {
      justify-content: center;
    }
  }
}
</style>
